import { fromJS } from 'immutable';

const urlReducer = (state = fromJS({})) => state;

export type Request = { req?: { body?: unknown; url: string } & { [key: string]: unknown } };

urlReducer.buildInitialState = ({ req }: Request = {}) => req?.url;

export default urlReducer;
